"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProduct = useProduct;
var _router = _interopRequireDefault(require("@/router"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function useProduct() {
  //商品类型
  var productTypeList = [{
    label: '普通商品',
    value: 0
  }, {
    label: '虚拟商品',
    value: 2
  }, {
    label: '云盘商品',
    value: 5
  }, {
    label: '卡密商品',
    value: 6
  }, {
    label: '预约商品',
    value: 7
  }];

  //创建、编辑表单
  var handlerCreatFromUse = function handlerCreatFromUse(id, type) {
    var _router$resolve = _router.default.resolve({
        path: "/page/maintain/creatSystemFrom/".concat(id, "/").concat(type)
      }),
      href = _router$resolve.href;
    window.open(href);
  };
  return {
    productTypeList: productTypeList,
    handlerCreatFromUse: handlerCreatFromUse
  };
}